import React from "react";
import { GET_REQUEST, POST_REQUEST } from "~/HooksApi/useApi";
import { Checkbox, FormControlLabel } from "@mui/material";
import { MuiButton } from "../../../Components/Form";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { USeInsertData } from "../../../HookAxios/postData";
import UseGetData from "~/HookAxios/getdata";
import Dots from "../../../Components/Loader/Dots";
import * as Styled from "./StyledEnrollCourse";
import * as images from "./data/images";
import * as Comp from "./Components";
const EnrollCourse = () => {
  const navigate = useNavigate();
  const { idCourse } = useParams();
  const CorseSelected = useSelector((state) => state.Courses.AboutCourse.data);
  const token = useSelector((state) => state.Auth.userInfo.token);
  const { isLoading, data } = GET_REQUEST({
    queryKey: `getSmilerCourse${idCourse}`,
    request: () =>
      UseGetData(
        "get_simillar_demend_courses",
        { id: idCourse },
        { Authorization: `Bearer ${token}` }
      ),
    enabled: true,
  });
  const {
    mutate: enrollCourse,
    status: StatusEnrollCourse,
    data: dataEnrollCourse,
    error: errorEnrollCourse,
  } = POST_REQUEST({
    request: (data) =>
      USeInsertData("subscribe_to_course", data, {
        Authorization: `Bearer ${token}`,
      }),
    handelOnSettledError,
    handelOnSettledData,
  });
  function handelOnSettledError(error) {}
  function handelOnSettledData(data) {
    navigate(`/course-description/${idCourse}`);
  }
  const [state, setState] = React.useState([
    {
      PrimeSub: {
        checked: true,
        cost: CorseSelected.cost,
        id: CorseSelected.id,
      },
    },
  ]);

  const handleChange = (event, id, cost) => {
    const { name, checked } = event.target;
    const newState = checked
      ? [...state, { [name]: { checked, cost: Number(cost), id } }]
      : state.filter(
          (obj) =>
            Object.values(obj)[0].id !== id && Object.values(obj)[0].checked
        );
    setState(newState);
  };
  const { checkedCost, uncheckedCost } = state.reduce(
    (acc, obj) => {
      const { checked, cost } = Object.values(obj)[0];
      if (checked) {
        acc.checkedCost += parseInt(cost);
      } else {
        acc.uncheckedCost += parseInt(cost);
      }
      return acc;
    },
    { checkedCost: 0, uncheckedCost: 0 }
  );
  const totalCost = checkedCost - uncheckedCost;
  const checkedCourseIds = [
    ...new Set(
      state
        .filter((obj) => Object.values(obj)[0].checked)
        .map((obj) => Object.values(obj)[0].id)
    ),
  ];
  return (
    <Styled.Section>
      <Styled.RightSection>
        <Styled.HeadSection>التسجيل في الدورة</Styled.HeadSection>
        <Styled.SubComp>
          <Styled.SubCompContent>
            <FormControlLabel
              control={
                <Checkbox
                  checked={state[0].PrimeSub.checked}
                  disabled
                  onChange={handleChange}
                  name="PrimeSub"
                  value={CorseSelected.cost}
                />
              }
            />
            <Styled.ImageSub>
              <Styled.Image
                src={`${process.env.REACT_APP_BASE_URL}${CorseSelected.image_path}`}
              />
            </Styled.ImageSub>
            <Styled.TextComp>
              <Styled.HeadSub>{CorseSelected.name}</Styled.HeadSub>
              <Styled.TextDiscretion>
                {CorseSelected.date_of_create &&
                  `-   ${CorseSelected.date_of_create}`}{" "}
                {CorseSelected.teacher_name}
              </Styled.TextDiscretion>
            </Styled.TextComp>
          </Styled.SubCompContent>
        </Styled.SubComp>
        <Styled.SubCompContent>
          <Styled.TextHead>مواد المنهاج</Styled.TextHead>
          <Styled.TextDiscretion>يمكنك إضافة مواد أخرى</Styled.TextDiscretion>
        </Styled.SubCompContent>
        {!isLoading && data ? (
          data.data.data.courses.map((sub, idx) => (
            <Styled.SubComp key={sub.id}>
              <Styled.SubCompContent>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => [handleChange(e, sub.id, sub.cost)]}
                      name={`option${idx}`}
                    />
                  }
                />
                <Styled.ImageSub>
                  <Styled.Image
                    src={`${process.env.REACT_APP_BASE_URL}${sub.image_path}`}
                  />
                </Styled.ImageSub>
                <Styled.TextComp>
                  <Styled.HeadSub>{sub.name}</Styled.HeadSub>
                  <Styled.TextDiscretion>
                    {sub.teacher_name}
                    {sub.date_course && `-  ${sub.date_course}`}
                  </Styled.TextDiscretion>
                </Styled.TextComp>
              </Styled.SubCompContent>
              <Styled.HeadSub
                sx={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <span>{sub.cost}</span>
                نقطة
              </Styled.HeadSub>
            </Styled.SubComp>
          ))
        ) : (
          <Dots />
        )}
      </Styled.RightSection>
      <Styled.LeftSection>
        <Styled.HeadSection>الدفع</Styled.HeadSection>
        <Styled.TextPay>
          <img src={images.Info} alt="" style={{ margin: "0 5px" }} />
          سيتم اقتطاع
          <span style={{ fontWeight: "800", margin: "0 2px" }}>
            {CorseSelected.cost}{" "}
          </span>{" "}
          نقطة
          {false && <span> نقطة من رصيدك! وستحصل على 20 فيديو من أصل 40.</span>}
        </Styled.TextPay>
        <Comp.AddCoupon />
        <Styled.HeadSection>ادفع دفعة كاملة</Styled.HeadSection>
        <Styled.HeadSection first>أو التقسيط على:</Styled.HeadSection>
        <Styled.HeadSection>
          السعر النهائي (
          <span
            style={{
              color: "#0056D2",
            }}
          >
            {" "}
            {totalCost}نقطة
          </span>
          )
        </Styled.HeadSection>
        <MuiButton
          text="التسجيل"
          width="40%"
          margin=" 25px 5px "
          onClick={() => enrollCourse({ course_id: checkedCourseIds })}
        />
      </Styled.LeftSection>
    </Styled.Section>
  );
};

export default EnrollCourse;
